import { useRef, useMemo, DependencyList, EffectCallback, useEffect } from "react";
import { dequal as deepEqual } from "dequal";

export const useDeepCompareMemoize = (value: DependencyList) => {
  const ref = useRef<DependencyList>(value);

  if (!deepEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
};

export const useDeepCompareMemo = <T>(factory: () => Exclude<T, void>, dependencies: DependencyList) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(factory, useDeepCompareMemoize(dependencies));
};

export const useDeepCompareEffect = (effect: EffectCallback, dependencies: DependencyList) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(effect, useDeepCompareMemoize(dependencies));
};
